document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.pcard-variant-swatch');
  if (!swatch) return;

  const card = swatch.closest('.product-card');
  if (!card) return;

  const variantId = swatch.dataset.variantId || '';
  const priceCents = parseInt(swatch.dataset.price, 10);
  const comparePriceCents = parseInt(swatch.dataset.comparePrice, 10) || 0;
  const quantity = parseFloat(swatch.dataset.quantity);
  const unitLabel = swatch.dataset.unit || '';

  if (isNaN(priceCents)) return;

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, "{{ shop.money_format }}");
    }
    return '$' + (cents / 100).toFixed(2);
  }

  /* Update hidden variant input */
  const variantInput = card.querySelector('.product-variant-id');
  if (variantInput) {
    variantInput.value = variantId;
  }

  /* Update main price */
  const mainPriceEl = card.querySelector('[data-pro-price]');
  if (mainPriceEl) {
    mainPriceEl.innerHTML = formatMoney(priceCents);
  }

  /* Update compare price */
  let comparePriceEl = card.querySelector('[data-pro-comapre-price]');

  if (comparePriceCents > priceCents) {
    if (!comparePriceEl) {
      comparePriceEl = document.createElement('s');
      comparePriceEl.setAttribute('data-pro-comapre-price', '');
      mainPriceEl.insertAdjacentElement('afterend', comparePriceEl);
    }
    comparePriceEl.innerHTML = formatMoney(comparePriceCents);
    comparePriceEl.style.display = '';
  } else if (comparePriceEl) {
    comparePriceEl.style.display = 'none';
    comparePriceEl.innerHTML = '';
  }

  /* Update per price */
  const perPriceEl = card.querySelector('.pcard-per-price');
  if (perPriceEl) {
    if (!isNaN(quantity) && quantity > 0) {
      let unitPriceCents = priceCents / quantity;
      unitPriceCents = Math.floor(unitPriceCents + 0.00001);
      perPriceEl.innerHTML = formatMoney(unitPriceCents) + (unitLabel ? ' per ' + unitLabel : '');
      perPriceEl.style.display = '';
    } else {
      perPriceEl.innerHTML = '';
      perPriceEl.style.display = 'none';
    }
  }

  /* Active swatch */
  card.querySelectorAll('.pcard-variant-swatch').forEach(function(item) {
    item.classList.remove('active');
  });
  swatch.classList.add('active');
});